import React from "react";

const NotAllowed = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <h1 className="text-2xl font-semibold mb-4">Тут нічого немає 🤷</h1>
        <p className="text-gray-600">Вам нема доступу до цього застосунку.</p>
      </div>
    </div>
  );
};

export default NotAllowed;
